import {Button, Modal} from 'react-bootstrap';
import './LoginTroubleModal.css'

function LoginTroubleModal({
    show,
    onClose,
    setForgotPassword,
    setForgotUsername
}) {

    const onForgotUsername = () => {
        onClose();
        setForgotUsername();
    }


    const onForgotPassword = () => {
        onClose();
        setForgotPassword();
    }
    
    return (
        <>
            <Modal show={show} onHide={onClose} animation={false}>
                <Modal.Header closeButton>
                    Login Help
                </Modal.Header>
                <Modal.Body className='login-trouble-buttons'>
                    <Button variant="primary" onClick={onForgotUsername}>
                        Forgot Username
                    </Button>
                    <Button variant="primary" onClick={onForgotPassword}>
                        Forgot Password
                    </Button>
                </Modal.Body>
            </Modal>
        </>       
    );

}

export default LoginTroubleModal;